import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Modal,
    OutlinedInput,
    Paper,
    Select,
    TextField,
    Typography
} from "@mui/material"
import { useEffect, useRef, useState } from "react"
import DataGridTable from "./common/DataGridTable"
import DebugService from "../services/DebugService"
import TableLoader from "./common/contentloader/TableLoader"
import { LoadingButton } from "@mui/lab"
import {
    BLOCK_CONTAINER_ICON,
    CONST_SITE_LABEL,
    STORAGE_KEYS,
    setScopedItem
} from "./common/Helper"
import SnackbarNotification, { SNACKBAR_THEME } from "./common/SnackbarNotification"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { BlockContainer } from "./common/BlockContainer"
import { TbPlugConnectedX } from "react-icons/tb";
import ConnectionApiService from "../services/ConnectionApiService"
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { MdOutlineArticle } from "react-icons/md";
import AnsiToHtml from "ansi-to-html";
import { AiOutlineClose } from "react-icons/ai";
import { useAuth } from "../state/AuthContext"
import { useScopedLocalStorage } from "../hooks/useScopedLocalStorage"
import './common/Styles.css'
import { IoCloseCircleOutline } from "react-icons/io5"
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


const ansiConverter = new AnsiToHtml();

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const CustomUserTextField = (props) => {
    return (
        <TextField
            autoComplete="off"
            required={props['required']}
            fullWidth
            size="small"
            error={![null, undefined].includes(props['errorKey'])}
            helperText={props['errorKey']}
            inputProps={{ readOnly: props['readonly'] }}
            {...props}
        />
    )
}

/**
 * Add Connection Modal
 * @param {*} props 
 * @returns 
 */
export const AddConnectionModal = (props) => {
    const [isOpen, setIsOpen] = useState(props['isOpen'] ?? false)
    const [isSaveDisabled, setIsSaveDisabled] = useState(true)
    const [showPassword, setShowPassword] = useState(false)
    const [errorMessages, setErrorMessages] = useState(null)
    const [connectionForm, setConnectionForm] = useState({
        hostName: '',
        infraType: 'AWS',
        connectionName: '',
        connectionPayload: '',
        connectionType: 'SSH',
        username: '',
        password: '',
        Pemfile: '',
        port: '',
    })

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setConnectionForm(prev => ({
                ...prev,
                Pemfile: file
            }))
        }
    };

    /**
     * Modal close handler
     */
    const closeHandler = () => {
        props['isClose'](true)
        setIsOpen(false)
        setIsSaveDisabled(true)
        setErrorMessages(null)
    }

    /**
     * Modal save click handler
     */
    const onSaveClick = () => {
        props['saveClickHandler'](connectionForm)
    }

    /**
     * call useEffect on user form change
     */
    useEffect(() => {
        DebugService.log(`Connection Modal: Form data`, connectionForm)

        if (
            connectionForm['hostName'] !== '' &&
            connectionForm['infraType'] !== '' &&
            connectionForm['connectionName'] !== '' &&
            connectionForm['username'] !== ''
        ) {
            setIsSaveDisabled(false)
        } else {
            setIsSaveDisabled(true)
        }
    }, [connectionForm])

    return (
        <Dialog open={isOpen} onClose={closeHandler} maxWidth="sm" PaperProps={{
            className: 'add-connection-dialog',
        }}>
             <Box className="add-connection-close-button">
                <IconButton onClick={closeHandler} size="medium">
                <IoCloseCircleOutline />
                </IconButton>
            </Box>
            <DialogTitle>
                <Typography variant="h5" className="add-connection-title">Add Connection</Typography>
            </DialogTitle>


            <DialogContent >
                <Box className="add-connection-Content">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" color={'#76818B'} mb={1}>
                            <strong>Note:</strong> Whitelist your IP 5.223.50.175 before connection.
                            </Typography>
                            <CustomUserTextField
                                label="Connection Name"
                                required
                                onChange={(e) => setConnectionForm(prev => {
                                    return {
                                        ...prev,
                                        connectionName: e['target']['value']
                                    }
                                })}
                                errorKey={errorMessages && errorMessages['connectionName']}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FormControl
                                fullWidth
                                size="small"
                                required
                                error={errorMessages && errorMessages['infraType'] !== undefined}
                            >
                                <InputLabel id="demo-simple-select-label">Select Your Infra Type</InputLabel>
                                <Select
                                    labelid="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Select Your Infra Type"
                                    onChange={(e) => setConnectionForm(prev => {
                                        return {
                                            ...prev,
                                            infraType: e['target']['value']
                                        }
                                    })}
                                    value={connectionForm['infraType']}
                                    IconComponent={KeyboardArrowDownIcon}
                                >
                                    <MenuItem selected={connectionForm['infraType'] === 'AWS'} value={'AWS'}>AWS</MenuItem>
                                    <MenuItem selected={connectionForm['infraType'] === 'AZURE'} value={'AZURE'}>Azure</MenuItem>
                                    <MenuItem selected={connectionForm['infraType'] === 'DATACENTER'} value={'DATACENTER'}>Data Center</MenuItem>
                                    <MenuItem selected={connectionForm['infraType'] === 'GCP'} value={'GCP'}>GCP</MenuItem>
                                    <MenuItem selected={connectionForm['infraType'] === 'ZTNA'} value={'ZTNA'}>ZTNA (VPN Tunnel)</MenuItem>
                                </Select>
                                <FormHelperText>{errorMessages && errorMessages['infraType']}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomUserTextField
                                label="Port"
                                defaultValue={connectionForm['port']}
                                onChange={(e) => setConnectionForm(prev => ({
                                    ...prev,
                                    port: e['target']['value']
                                }))}
                                errorKey={errorMessages && errorMessages['port']}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <CustomUserTextField
                                label="Connection Type"
                                readonly={true}
                                required
                                defaultValue={connectionForm['connectionType']}
                                errorKey={errorMessages && errorMessages['connectionType']}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <CustomUserTextField
                                label="Hostname (or IPaddress)"
                                required
                                onChange={(e) => setConnectionForm(prev => {
                                    return {
                                        ...prev,
                                        hostName: e['target']['value']
                                    }
                                })}
                                errorKey={errorMessages && errorMessages['hostName']}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <CustomUserTextField
                                label="Username"
                                required
                                onChange={(e) => setConnectionForm(prev => {
                                    return {
                                        ...prev,
                                        username: e['target']['value']
                                    }
                                })}
                                errorKey={errorMessages && errorMessages['username']}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl
                                fullWidth
                                size="small"
                                error={errorMessages && errorMessages['password'] !== undefined}
                            >
                                <InputLabel id="demo-simple-select-label">Password</InputLabel>
                                <OutlinedInput
                                    autoComplete="off"
                                    labelid="demo-simple-select-label"
                                    label="Password"
                                    type={showPassword ? 'text' : 'password'}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() => setShowPassword(prev => !prev)}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                    onChange={(e) => setConnectionForm(prev => {
                                        return {
                                            ...prev,
                                            password: e['target']['value']
                                        }
                                    })}
                                />
                                <FormHelperText>{errorMessages && errorMessages['password']}</FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12}>
                            <Box className="upload-pem-file-box">
                                <Button
                                    fullWidth
                                    component="label"
                                    variant="outlined"
                                    startIcon={<CloudUploadOutlinedIcon />}
                                    size="small"
                                    className="upload-pem-file-btn"
                                >
                                    <Typography variant="body2" color={`#425466`} fontWeight={600}>
                                        {connectionForm['Pemfile'] ? "Re-upload PEM File" : "Upload PEM File"} &nbsp;
                                    </Typography>
                                    <Typography variant="caption" color={'#A5AEB7'}>
                                        (optional)
                                    </Typography>
                                    <input
                                        type="file"
                                        accept=".pem"
                                        hidden
                                        onChange={(event) => handleFileChange(event)}
                                    />
                                </Button>

                                {connectionForm['Pemfile'] && (
                                    <Typography variant="body2" color="textSecondary" mt={1}>
                                        Uploaded: {connectionForm['Pemfile']?.name}
                                    </Typography>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                    {/* Form Actions */}
                    <Grid container spacing={1} >
                        {/* Cancel Button */}
                        <Grid item xs={12} md={3}></Grid>
                        <Grid item xs={12} md={3}></Grid>
                        <Grid item xs={12} md={3}>
                            <Button
                                fullWidth
                                variant='outlined'
                                onClick={() => closeHandler()}
                                className="cancel-btn"
                            >Cancel</Button>
                        </Grid>

                        {/* Connect Button */}
                        <Grid item xs={12} md={3}>
                            <Button
                                fullWidth
                                disabled={isSaveDisabled}
                                variant='contained'
                                type="submit"
                                title="Add Connection"
                                onClick={() => onSaveClick()}
                                className="connect-btn"
                            >Connect</Button>
                        </Grid>
                    </Grid>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

/**
 * Setup Infrastructure component
 * @returns 
 */
export const SetupInfrastructure = () => {
    // const [columnList, setColumnList] = useState([{}])
    const [data, setData] = useState([])
    const [logListData, setLogListData] = useState([])
    const [logOutput, setLogOutput] = useState([])
    const [showLogOutputModal, setShowLogOutputModal] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isLogsLoading, setIsLogsLoading] = useState(false)
    const [showAddModal, setShowAddModal] = useState(false)
    const [snackbarMessage, setSnackbarMessage] = useState(null)
    const [snackbarStatus, setSnackbarStatus] = useState(null)
    const [currentUserAccess, setCurrentUserAccess] = useState(null)
    const [logsListApiData, setLogsListApiData] = useState([])
    const [connectionListApiData, setConnectionListApiData] = useState([])
    const logContainerRef = useRef(null);
    const {selectedAccount} = useAuth()

    const { getScopedItem } = useScopedLocalStorage()

    const columnList = [
        {
            field: 'id',
            headerName: 'S.no',
            flex: 1,
            align: 'center'
        },
        {
            field: 'connectionName',
            headerName: 'Name',
            flex: 1,
            width: 200,
            align: 'center'
        },
        {
            field: 'connectionType',
            headerName: 'Type',
            flex: 1,
            align: 'center'
        },
        {
            field: 'infraType',
            headerName: 'Infra',
            flex: 1,
            align: 'center'
        },
        {
            field: 'hostName',
            headerName: 'Hostname',
            flex: 1,
            align: 'center'
        },
        {
            field: 'username',
            headerName: 'Username',
            flex: 1,
            align: 'center'
        },
        {
            field: 'createdBy',
            headerName: 'Created By',
            flex: 1,
            align: 'center'
        },
        {
            field: 'isActive',
            headerName: 'Status',
            flex: 1,
            align: 'center',
            renderCell: params => (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                >
                    <Box
                    bgcolor={params.value ? '#CFF2E9' : '#F6E2E9'}
                    px={2}
                    py={0.5}
                    borderRadius="16px"
                    minWidth="80px"
                    >
                    <Typography color={params.value ? '#43BA9F' : '#BA4345'}>
                        {params.value ? 'Active' : 'Inactive'}
                    </Typography>
                    </Box>
                </Box>
            )
        },
        {
            field: 'createdOn',
            headerName: 'Created On',
            flex: 1,
            width: 200,
            align: 'center'
        },
        {
            field: 'port',
            headerName: 'Port',
            flex: 1,
            align: 'center',
            renderCell: params => params.value ?? 'NA'
        },
        {
            field: 'viewLogs',
            headerName: 'Logs',
            flex: 1,
            align: 'center',
            renderCell: params => (
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%'
                }}>
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            fetchLogList(params.row.connectionId);
                        }}
                        style={{ display: 'flex', alignItems: 'center' }}
                    >
                        <img
                            src={`/view-icon.svg`}
                            alt="View"
                        />
                    </a>
                </div>
            )
        }
    ]

    const logsColumnList = [
        {
            field: 'id',
            headerName: 'S. no.',
            flex: 1,
            align: 'center'
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
            // width: 200,
            align: 'center'
        },
        {
            field: 'description',
            headerName: 'Description',
            flex: 1,
            // width: 200,
            align: 'center'
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            align: 'center',
            renderCell: params => (
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                >
                    <Box
                        bgcolor={
                        params.value === 'successful' ? '#CFF2E9' :
                        params.value === 'failed' ? '#F6E2E9' :
                        '#E0E0E0'
                        }
                        px={2}
                        py={0.5}
                        borderRadius="16px"
                        minWidth="80px"
                    >
                        <Typography
                        color={
                            params.value === 'successful' ? '#43BA9F' :
                            params.value === 'failed' ? '#BA4345' :
                            '#000'
                        }
                        >
                        {params.value}
                        </Typography>
                    </Box>
                </Box>
            )
        },
        {
            field: 'type',
            headerName: 'Source',
            flex: 1,
            // width: 200,
            align: 'center',
            renderCell: (params) => (
                params.value === 'job'
                    ? <span><MdOutlineArticle
                        color="#20a7db"
                        title="Click to view output"
                        style={{ cursor: 'pointer' }}
                        onClick={() => showLogsOutput(params.value, params.row.jobId)}
                    />&nbsp;Manage Service</span>
                    : <span><MdOutlineArticle
                        color="#20a7db"
                        title="Click to view output"
                        style={{ cursor: 'pointer' }}
                        onClick={() => showLogsOutput(params.value, params.row.jobId)}
                    />&nbsp;Execute Custom Command</span>
            )
        },
        {
            field: 'createdAt',
            headerName: 'Created On',
            flex: 1,
            width: 200,
            align: 'center'
        },
        {
            field: 'finishedAt',
            headerName: 'Completed On',
            flex: 1,
            width: 200,
            align: 'center'
        },
        {
            field: 'elapsedTime',
            headerName: 'Duration',
            flex: 1,
            align: 'center'
        },
    ]

    const showLogsOutput = (jobSource, jobID) => {
        const endpoint = jobSource === 'job' ? ConnectionApiService.getDeployServiceLogs : ConnectionApiService.getExecuteCommandLogs

        endpoint(selectedAccount, jobID)
            .then(res => {
                DebugService.log(`Setup Infrastructure Component: API response for job id ${jobID}`, res)
                const apiData = res['data'] ?? ''

                if (apiData['log'] && apiData['log']['content'] && apiData['log']['content'] !== '') {
                    setLogOutput(ansiConverter.toHtml(apiData['log']['content'].replace(/\n/g, "<br>")))
                    setShowLogOutputModal(true)
                }

                if (res['error']) {
                    DebugService.error(`Setup Infrastructure Component: Error caught while fetching data`, res['error'])
                }
            })
            .catch(err => {
                DebugService.error(`Setup Infrastructure Component: Error caught while fetching data`, err)
            })
    }

    /**
     * Fetch user data
     */
    const fetchLogList = (connectionId) => {
        setIsLogsLoading(true)

        ConnectionApiService.getAllLogsList(selectedAccount, connectionId)
            .then(res => {
                DebugService.log(`Setup Infrastructure Component: API response for log list`, res)
                setLogsListApiData(res)
                const apiData = res['data'] ?? []
                setLogListData(apiData.map((d, i) => {
                    return {
                        ...d,
                        id: (i + 1),
                        createdAt: (new Date(d['createdAt'])).toISOString().replace("T", " ").replace(/\.\d{3}Z$/, " UTC") ?? '',
                        finishedAt: (new Date(d['finishedAt'])).toISOString().replace("T", " ").replace(/\.\d{3}Z$/, " UTC") ?? '',
                        elapsedTime: `${d['elapsedTime']} seconds`,
                        viewLogs: true
                    }
                }))

                if (res['error']) {
                    DebugService.error(`Setup Infrastructure Component: Error caught while fetching log list`, res['error'])
                }

                setIsLogsLoading(false)
            })
            .catch(err => {
                DebugService.error(`Setup Infrastructure Component: Error caught while fetching log list`, err)
                setIsLogsLoading(false)
            })
    }

    /**
     * Fetch user data
     */
    const fetchData = () => {
        setIsLoading(true)

        ConnectionApiService.getData(selectedAccount)
            .then(res => {
                DebugService.log(`Setup Infrastructure Component: API response`, res)
                setConnectionListApiData(res)
                const apiData = res['data'] ?? []
                setData(apiData.map((d, i) => {
                    return {
                        ...d,
                        id: (i + 1),
                        createdOn: (new Date(d['createdOn'])).toISOString().replace("T", " ").replace(/\.\d{3}Z$/, " UTC") ?? '',
                        viewLogs: true
                    }
                }))

                if (res['error']) {
                    DebugService.error(`Setup Infrastructure Component: Error caught while fetching data`, res['error'])
                }

                setIsLoading(false)
            })
            .catch(err => {
                DebugService.error(`Setup Infrastructure Component: Error caught while fetching data`, err)
                setIsLoading(false)
            })
    }

    /**
     * Call useEffect on page load
     */
    useEffect(() => {
        document.title = `${CONST_SITE_LABEL} | Setup Infrastructure `
        fetchData()

        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)
        setCurrentUserAccess(parseToJson['roleName'])
    }, [])

    useEffect(() => {
        fetchData()
    }, [selectedAccount])

    /**
    * @description Stores the latest API response in storage.
    * @author Ashish Sharma
    */
    useEffect(() => {
        setScopedItem(STORAGE_KEYS.AI_CHATBOT_REQUEST_DATA,{
          logsListApiData: logsListApiData, 
          connectionListApiData: connectionListApiData  
        })
    },[logsListApiData, connectionListApiData]);

    /**
     * API call handler
     * @param {*} endpoint 
     * @param {*} requestBody 
     */
    const saveAPICallHandler = (endpoint, requestBody) => {
        setSnackbarStatus(null)
        setSnackbarMessage(null)
        DebugService.log(`Setup Infrastructure Component: Request to add connection initiated`, requestBody)

        ConnectionApiService.saveData(endpoint, requestBody)
            .then(res => {
                DebugService.log(`Setup Infrastructure Component: API response`, res)

                if (res['data']) {
                    setShowAddModal(false)
                    setSnackbarStatus('success')
                    setSnackbarMessage(res['data']['message'] ?? 'Connection Added Successfully')
                    setTimeout(() => {
                        fetchData()
                    }, 1000)
                }

                if (res['error']) {
                    setSnackbarStatus('failed')
                    setSnackbarMessage(res['error']['message'])
                }

                setIsLoading(false)
            })
            .catch(err => {
                DebugService.log(`Setup Infrastructure Component: Failed to save data`, err)
                setIsLoading(false)
                setSnackbarStatus('failed')
                setSnackbarMessage('Something went wrong. Please try later')
            })
    }

    /**
     * Add new connection handler
     * @param {*} formDetails 
     */
    const onSaveClickHandler = (formDetails) => {
        DebugService.log(`Setup Infrastructure Component: Form Data`, formDetails)
        setIsLoading(true)
        setSnackbarMessage(null)
        setSnackbarStatus(null)

        const requestBody = {
            hostName: formDetails['hostName'],
            infraType: formDetails['infraType'],
            connectionName: formDetails['connectionName'],
            username: formDetails['username'],
            password: formDetails['password'],
            connectionType: formDetails['connectionType'],
            pemfile: formDetails['Pemfile'],
            port: formDetails['port'],
        }

        const userDetails = getScopedItem(STORAGE_KEYS.LOCAL_USER_DETAILS)
        const parseToJson = JSON.parse(userDetails)

        if (selectedAccount) {
            requestBody['userAccountId'] = selectedAccount
        }

        if (parseToJson['userId']) {
            requestBody['userId'] = parseToJson['userId']
        }

        // Convert request body into form data
        const formData = new FormData()
        Object.entries(requestBody).forEach(([k, v]) => {
            formData.append(k, v)
        })

        saveAPICallHandler(formData)
    }

    return (
        <Grid container spacing={3} className="setup-infrastructure-page">
            <div className="gradient-box">

            </div>
            <Grid item container >
                <Grid item xs={12} sm={3} lg={5}></Grid>
                <Grid item xs={12} sm={3} lg={4}></Grid>
                <Grid item xs={12} sm={6} lg={3}>
                    <LoadingButton
                        className="new-connection-btn"
                        fullWidth
                        variant="contained"
                        size="large"
                        title="Add New Connection"
                        loading={isLoading}
                        loadingPosition="end"
                        endIcon={<img src="/new-connection-icon.svg" />}
                        onClick={() => setShowAddModal(true)}
                    >
                        New Connections
                    </LoadingButton>
                </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
                <BlockContainer
                order={1}
                displayIcon={BLOCK_CONTAINER_ICON.SETUP_INFRASTRUCTURE}
                displayValue={data.length}
                displayLabel={"Total List"}
                unitValue={""}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <BlockContainer
                order={3}
                displayIcon={BLOCK_CONTAINER_ICON.SETUP_INFRASTRUCTURE}
                displayValue={data.filter((u) => u["isActive"]).length}
                displayLabel={"Active Connections"}
                unitValue={""}
                />
            </Grid>
            <Grid item xs={12} md={4}>
                <BlockContainer
                order={5}
                displayIcon={BLOCK_CONTAINER_ICON.SETUP_INFRASTRUCTURE}
                displayValue={data.filter((u) => !u["isActive"]).length}
                displayLabel={"Inactive Connections"}
                unitValue={""}
                />
            </Grid>

            {/* Connection List */}
            <Grid item xs={12} >
                {isLoading && <TableLoader />}
                {!isLoading && (
                <DataGridTable
                    headerBgColor={'#506C84'}
                    actionIconColor={'#506C84'}
                    evenRowBgColor={'#FFF'}
                    columns={columnList}
                    rows={data}
                    showTooltip={false}
                    showPagination={true}
                />
                )}
            </Grid>

            {/* Service List */}
            {isLogsLoading && <TableLoader />}
            {!isLogsLoading && logListData.length > 0 && (
                <>
                <Grid item xs={12}>
                <div className="log-tag">
                    <p className="log-tag-text">{logListData.length} Logs</p>
                </div>
                </Grid>

                <Grid item xs={12}>
                    <DataGridTable
                    headerBgColor={'#506C84'}
                    actionIconColor={'#506C84'}
                    evenRowBgColor={'#FFF'}
                    columns={logsColumnList}
                    rows={logListData}
                    showTooltip={false}
                    showPagination={true}
                    />
                </Grid>
                </>
            )}

            {/* Add Connection Modal */}
            {showAddModal && (
                <AddConnectionModal
                isClose={(isCloseConfirm) => setShowAddModal(!isCloseConfirm)}
                isOpen={true}
                saveClickHandler={(formDetails) => onSaveClickHandler(formDetails)}
                />
            )}

            {showLogOutputModal && (
                <div>
                <Dialog open={true} onClose={() => setShowLogOutputModal(false)} maxWidth="sm" PaperProps={{
                    className: 'add-connection-dialog',
                }}>
                    <Box className="add-connection-close-button">
                        <IconButton onClick={() => setShowLogOutputModal(false)} size="medium">
                        <IoCloseCircleOutline />
                        </IconButton>
                    </Box>
                    <DialogTitle>
                        <Typography variant="h5" className="add-connection-title">Log Output</Typography>
                    </DialogTitle>

                    <DialogContent >

                   <Box>
                        <Paper
                        elevation={3}
                        className="logs-container"
                        ref={logContainerRef}
                        >
                        <pre className="log-pre" dangerouslySetInnerHTML={{ __html: logOutput }} />
                        </Paper>
                    </Box>
                    </DialogContent>
                </Dialog>

                </div>
            )}

            {/* Snackbar Notification */}
            {snackbarStatus && (
                <SnackbarNotification
                initialOpen={true}
                duration={5000}
                message={snackbarMessage}
                actionButtonName={"Ok"}
                theme={
                    snackbarStatus === "success" ? SNACKBAR_THEME.GREEN : SNACKBAR_THEME.RED
                }
                yPosition={"top"}
                xPosition={"center"}
                />
            )}
        </Grid>
    )
}